import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import { gateVoiceSchema } from "./voiceAddSchema";
import {
  ModalBody
} from "reactstrap";
import { store } from "../../redux/storeConfig/store";
import { createGate, updateGate, getClassGroups } from "../../redux/actions/api/apiAction";
import Title from "../title";
import SpinnerComponent from "../spinner/spinner";
import { weekDays } from "../appointment/utils";
import { connect } from "react-redux";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";


function MultiStepForGate({
  name,
  type,
  isEdit,
  gateId,
  linkedClasses: initialLinkedClasses,
  classes,
  handleSubmit
}) {
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
    // Fetch classes when the component mounts
    store.dispatch(getClassGroups({ isActive: true }));
  }, []);
  
  const handleOpeningScheduleObject = (data) => {
    const openingSchedule = {
      days: {}
    };
    const { maleSchedule, femaleSchedule, maleDays, maleTime, femaleDays, femaleTime} = data;
    if (maleSchedule != "custom" || femaleSchedule != "custom" || !maleDays || !maleTime || !femaleDays || !femaleTime) {
      return null;
    }

    //check male days
    maleDays.forEach(d => {
      if (maleTime && maleTime[0] && maleTime[0].from && maleTime[0].to) {
        if (!openingSchedule.days[d]) {
          openingSchedule.days[d] = {};
        }
        openingSchedule.days[d]["male"] = `${maleTime[0].from}-${maleTime[0].to}`; 
      }
    });
    //check female days
    femaleDays.forEach(d => {
      if (femaleTime && femaleTime[0] && femaleTime[0].from && femaleTime[0].to) {
        if (!openingSchedule.days[d]) {
          openingSchedule.days[d] = {};
        }
        openingSchedule.days[d]["female"] = `${femaleTime[0].from}-${femaleTime[0].to}`; 
      }
    });

    return openingSchedule;
  };
  handleSubmit = async (values) => {
    if (saveVoiceDraftEdit(values)) return;
    const openingSchedule = handleOpeningScheduleObject(values);
    if (openingSchedule) {
      values.openingSchedule = openingSchedule;
    }
    console.log('values gate:', values);
    setIsLoading(true);
    if (isEdit && gateId) {
      await store.dispatch(updateGate(gateId, { 
        gateName: values.name, 
        type: values.type, 
        openingSchedule: values.openingSchedule,
        linkedClasses: values.linkedClasses || []
      }));
    } else {
      await store.dispatch(createGate({
        ...values,
        linkedClasses: values.linkedClasses || []
      }));
    }
  };

  const formSchema = gateVoiceSchema;

  return (
    <>
      <ModalBody className="wod-first-step">
        <div className="modal-body-content">
          <div className="add-member-popup adding-popup bg-white card-panel">
            {/* <div className="basic-info" style={{height: "50vh"}}> */}
            <div className="basic-info">
              <div className="info-title with-border">
                <Title
                  title={isEdit ? "Edit Gate" : "Add Gate"}
                  subtitlestyle="ctf-tx-secondary"
                  subtitle={isEdit ? "Edit info about Gate" : "Add info about Gate"}
                />
              </div>
              {isLoading ?
                  <div
                    style={{ height: "90%" }}
                    className="d-flex flex-column align-items-center justify-content-center"
                  >
                    <SpinnerComponent />
                    <h3>Please wait</h3>
                </div>
                :
                <Formik
                  enableReinitialize
                  initialValues={withVoicePrefill("gate", {
                    name,
                    type,
                    linkedClasses: initialLinkedClasses || []
                  })}
                  onSubmit={handleSubmit}
                  validationSchema={formSchema}
                >
                  {({
                    errors,
                    touched,
                    values,
                    setFieldValue,
                  }) => (
                    <Form className="d-flex flex-column justify-content-between h-100">
                      <FormFirstStep
                        errors={errors}
                        touched={touched}
                        values={values}
                        setFieldValue={setFieldValue}
                        classes={classes}
                      />
                      <StepButton isEdit={isEdit}/>
                    </Form>
                  )}
                </Formik>
              }
            </div>
          </div>
        </div>
      </ModalBody>
    </>
  );
};

MultiStepForGate.defaultProps = {
  name: "",
  type: "",
  isEdit: false,
  gateId: null,
  linkedClasses: [],
  classes: [],
  handleSubmit: () => {}
};

const mapStateToProps = (state) => {
  const { classes } = state.class;
  return { classes };
};

export default connect(mapStateToProps)(MultiStepForGate);
